import { getDescLanguageList } from "src/apis/descLanguageApi";
import { DescLanguageDto } from "src/dtos/descLanguage/descLanguageDto";
import { create } from "zustand";

const SELECTED_LANGUAGE_STORAGE_KEY = "selectedLanguageCd";

export interface DescLanguageStore {
	descLanguageList: DescLanguageDto[];
	setDescLanguageList: (list: DescLanguageDto[]) => void;

	// commentCd 기준 빠른 조회용
	descLanguageMap: Map<string, DescLanguageDto>;
	setDescLanguageMap: (data: Map<string, DescLanguageDto>) => void;

	selectedLanguageCd: string;
	setSelectedLanguageCd: (minorCd: string) => void;

	fetchDescLanguageCode: (
		searchText?: string,
		workplaceCd?: string,
		itemCd?: string
	) => Promise<DescLanguageDto[]>;

	initData: () => void;
}

export const useDescLanguageStore = create<DescLanguageStore>((set) => ({
	descLanguageList: [],
	setDescLanguageList: (list: DescLanguageDto[]) => set((state) => ({
		...state,
		descLanguageList: list,
	})),

	descLanguageMap: new Map<string, DescLanguageDto>(),
	setDescLanguageMap: (data: Map<string, DescLanguageDto>) => set((state) => ({
		...state,
		descLanguageMap: data,
	})),

	selectedLanguageCd: localStorage.getItem(SELECTED_LANGUAGE_STORAGE_KEY) ?? "KO",
	setSelectedLanguageCd: (minorCd: string) => {
		localStorage.setItem(SELECTED_LANGUAGE_STORAGE_KEY, minorCd);
		set({ selectedLanguageCd: minorCd });
	},

	fetchDescLanguageCode: async (
		searchText: string = '',
		workplaceCd: string = '',
		itemCd: string = ''
	) => {
		const response = await getDescLanguageList(searchText, workplaceCd, itemCd);
		const newList = response.data.data;
		const newMap = new Map<string, DescLanguageDto>();

		if (Array.isArray(newList)) {
			newList.forEach((item) => {
				newMap.set(item.commentCd, item);
			});
			set({ descLanguageList: newList, descLanguageMap: newMap });
		} else {
			set({ descLanguageList: [], descLanguageMap: newMap });
		}

		return Array.isArray(newList) ? newList : [];
	},

	initData: () => set((state) => ({
		...state,
		descLanguageList: [],
		descLanguageMap: new Map<string, DescLanguageDto>(),
	})),
}));
